import PropTypes from "prop-types";
import { IconButton, Stack, SvgIcon, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

export const DialogTitle = ({ onClose }) => {
  const { t } = useTranslation();
  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        alignItems: "center",
        justifyContent: "space-between",
        px: 3,
        py: 2,
      }}
    >
      <Typography variant="h6">{t("search.title")}</Typography>
      <IconButton color="inherit" onClick={onClose}>
        <SvgIcon>
          <FontAwesomeIcon icon={faXmark} />
        </SvgIcon>
      </IconButton>
    </Stack>
  );
};

DialogTitle.propTypes = {
  onClose: PropTypes.func,
};
